export default {
    action: function (game, reset) {

        if (reset) {
            game.pipes.reset();
            game.sack.speedReset();
            game.score.reset();
            game.state.current = game.state.getReady;
            return 
        }

         switch (game.state.current) {
            case game.state.game:
                if (game.sack.y - game.sack.radius <= 0) return;
                game.sack.flap(game);
                break;
            case game.state.getReady:
                game.state.current = game.state.game;
                break;
            case game.state.over:
                game.pipes.reset();
                game.sack.speedReset();
                game.score.reset();
                game.state.current = game.state.getReady;
    
                break;
        }
    }
}